<template>
  <div class="hover-animation-container" :class="{ 'disabled': !isAvailable }">
    <v-card flat @click="onMenuClicked" :class="{ 'clickable': isAvailable }">
      <div v-if="showImage">
        <v-img
          :src="menuImage"
          aspect-ratio="1.3"
          class="menu-image"
          @error="onError()"
        />
      </div>
      <!-- When there's no image, the hours block covers the name. So use an invisible block to accocate the space -->
      <!-- <div v-else-if="$vuetify.breakpoint.name == 'xs' && buildRenderMobile" v-html="buildRenderMobile" class="mobileDetails" style="visibility: hidden;"> </div> -->

      <div class="menuTitle title" :class="{ 'block-with-text': showImage || menuDescription }"> 
        {{ menuName }} 
      </div> 

      <div v-if="menuDescription"
        class="menuDescription"
        v-html="menuDescription.replaceAll('\n', '<br>')"
      > </div> 
      
    <v-card-text style="text-align: start; padding-top: 5px !important" v-if="menu.unavailable && menu.schedule" >
      <div v-if="getMenuSchedulesStartEnd && getMenuSchedulesStartEnd.length > 0" 
          style="background-color: rgba(var(--v-primary-base), 0.1); border-radius: 4px;" class="sched-container">
        <strong>{{ $vuetify.t('$vuetify.common.nextAvailable') }}:</strong> 
        <span v-if="getMenuSchedulesStartEnd[0]">
          <strong>{{ getMenuSchedulesStartEnd[0].nextAvailableDay ? formatDay(getMenuSchedulesStartEnd[0].nextAvailableDay) : 
            getDayByOffset(getMenuSchedulesStartEnd[0].dayIndex) }}: </strong>
          {{ buildTime(getMenuSchedulesStartEnd[0].start) }} - {{ buildTime(getMenuSchedulesStartEnd[0].end) }}
        </span>
      </div>
      <div v-if="!getMenuSchedulesStartEnd || !getMenuSchedulesStartEnd.length || !getMenuSchedulesStartEnd[0].nextAvailableDay && getMenuSchedulesStartEnd[0].dayIndex === undefined" style="margin-top: 10px;">
        <div v-for="(schedule, index) in menu.schedule.items" :key="index" style="margin-top: 2.5px;">
          <strong v-for="(day, dayIndex) in schedule.days" :key="dayIndex">
            {{ formatDay(day) }}<span v-if="dayIndex < schedule.days.length - 1">, </span>
          </strong>
          : 
          <span v-for="(time, timeIndex) in schedule.timeRange" :key="timeIndex">
            ({{ formatTime(time.start) }} - {{ formatTime(time.end) }})
          </span>
        </div>
      </div>
    </v-card-text>
      <!-- <div v-if="$vuetify.breakpoint.name == 'xs' && buildRenderMobile" class="mobileDetails fixed-details" v-html="buildRenderMobile"> </div> -->
      <!-- <div v-if="!!buildRender" id="hoverOverlay" v-html="buildRender"> </div> -->
    </v-card>
    <v-dialog class="rounded" v-model="showConfirmationDialog" max-width="450px" min-width="350px">
      <v-card class="rounded-card">
        <v-btn
          icon
          class="close-btn"
          @click="closeModal"
        >
          <i class="v-icon material-icons">cancel</i>
        </v-btn>
        <v-card-title class="card-title">
            <h2 class="title-text">{{ $vuetify.t('$vuetify.menu.menuAvailability') }}</h2>
        </v-card-title>
        <v-card-text style="text-align: start;" >
          <span>{{ $vuetify.t('$vuetify.menu.onlyAvailable') }}</span>
          <div style="margin-top: 10px;">
              <div v-for="(schedule, index) in menuSchedule" :key="index" style="margin-top: 2.5px;">
                <strong v-for="(day, dayIndex) in schedule.days" :key="dayIndex">
                  {{ formatDay(day) }}<span v-if="dayIndex < schedule.days.length - 1">, </span>
                </strong>
                : 
                <span v-for="(time, timeIndex) in schedule.timeRange" :key="timeIndex">
                  ({{ formatTime(time.start) }} - {{ formatTime(time.end) }})
                </span>
              </div>
            </div>
        </v-card-text>
        <v-card-actions style="justify-content: center;">
          <v-btn color="primary" class="rounded-btn" text @click="confirmNavigation">
            <span>{{ $vuetify.t('$vuetify.menu.gotIt') }}</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import get from 'lodash/get';

  import { mapGetters, mapActions } from 'vuex'

  import { formatTime, revertTimeFraction, matchTranslation, isNullOrEmpty } from '@/services/util.service'
  import { allNextAvailableDaySchedules } from '@/services/schedule.service'

  export default {
    props: {
      menu: Object
    },

    data() {
      return {
        imageError: false,
        showConfirmationDialog: false,
        pendingNavigation: null,
        menuSchedule: null
      }
    },
    created() {
      const tid = this.$route.query['tid'];
      const restrictMenu = get(this.getStore, 'settings.orderSettings.restrictMenuOnDiningTable');

      if (restrictMenu && tid) {
        this.$store.dispatch('fetchAssignedMenus', tid);
      }

      this.$watch(
        'getTableId',
        (newTableId) => {
          if (newTableId) {
            this.$store.dispatch('fetchAssignedMenus', newTableId);
          }
        },
        { immediate: true } 
      );
    },
    computed: {
      restrictedAssignedMenus() {
        return this.$store.getters.getAssignedMenus;
      },
      hasImage() {
        return !!this.menuImage
      },
      menuImage() {
        const path = process.env.VUE_APP_API_IMAGE
        const imgPath = get(this.menu, 'imageUrl', '')
        if (imgPath.startsWith('https://')) {
          return imgPath
        } else {
         return path && imgPath ? `${path}${imgPath}` : null
        }
      },
      showImage() {
        return this.hasImage && !this.imageError
      },
      
      isUnavailable() {
        return this.menu.unavailable || false;
      },
      menuName() {
        const _name = get(this.menu.name, 'translations', [])

        if (!isNullOrEmpty(_name))
          return matchTranslation(_name)
        return ''
      },

      menuDescription() {
        const _desc = get(this.menu.description, 'translations', [])

        if (!isNullOrEmpty(_desc))
          return matchTranslation(_desc)
        return ''
      },

      getMenuSchedulesStartEnd() {
        return allNextAvailableDaySchedules(get(this.menu, 'schedule.items', []) || [])
      },

      // buildRender() {
      //   const schedules = this.getMenuSchedulesStartEnd

      //   if (!isNullOrEmpty(schedules)) {
      //     const { nextAvailableDay } = schedules[0]

      //     return `
      //       <h1>
      //         ${this.menuName}
      //       </h1>
      //       ${!!nextAvailableDay
      //         ? `<h3 style="margin-top: 10px">
      //           ${this.$vuetify.t('$vuetify.menu.dayAvailable')}: ${this.$capatalize(nextAvailableDay)}
      //         </h3>`
      //         : ''}
      //       <h3 style="margin-top: 10px">
      //         ${this.$vuetify.t('$vuetify.menu.available')}
      //       </h3>
      //       ${schedules.map(_schedule => `${this.buildTime(_schedule.start)} - ${this.buildTime(_schedule.end)}`).join(',<br>')}
      //     `
      //   }

      //   return ''
      // },
     buildRender() {
  const schedules = get(this.menu, 'schedule.items', []); // Get the schedule items from the menu

  if (!isNullOrEmpty(schedules)) {
    const { nextAvailableDay } = allNextAvailableDaySchedules(schedules)[0] || {};

    return `
      <h1>
        ${this.menuName}
      </h1>
      ${!!nextAvailableDay
        ? `<h3 style="margin-top: 10px">
          ${this.$vuetify.t('$vuetify.menu.dayAvailable')}: ${this.$capatalize(nextAvailableDay)}
        </h3>`
        : ''}
      <h3 style="margin-top: 10px">
        ${this.$vuetify.t('$vuetify.menu.available')}
      </h3>
      ${schedules
        .map(
          (_schedule) =>
            `${this.buildTime(_schedule.start)} - ${this.buildTime(_schedule.end)}`
        )
        .join(',<br>')}
    `;
  }

  return '';
},
      buildRenderMobile() {
        const schedules = this.getMenuSchedulesStartEnd

        if (!isNullOrEmpty(schedules)) {
          const { nextAvailableDay } = schedules[0]

          return `
            <h3>
              ${this.$vuetify.t('$vuetify.menu.available')}:
            </h3>
            ${!!nextAvailableDay
              ? `<div style="margin-top: 10px">
                ${this.$vuetify.t('$vuetify.menu.dayAvailable')}: ${this.$capatalize(nextAvailableDay)}
              </div>`
              : ''}
            <div style="margin-top: 10px">
              ${this.$vuetify.t('$vuetify.menu.available')}
            </div>
            ${schedules.map(_schedule => `${this.buildTime(_schedule.start)} - ${this.buildTime(_schedule.end)}`).join(',<br>')}
          `
        }

        return ''
      },

      isAvailable() {
        const tid = this.$route.query['tid'];
        const restrictMenu = get(this.getStore, 'settings.orderSettings.restrictMenuOnDiningTable');

        if (restrictMenu && tid) {
            const assignedMenus = this.restrictedAssignedMenus;
            if (!assignedMenus || !Array.isArray(assignedMenus)) {
            return false;
            }
            const isMenuAssigned = assignedMenus.some(menu => menu === this.menu.code);
            return isMenuAssigned;
        }
        return this.assignedMenuIsAllowed(this.menu);
      },

      ...mapGetters([
        'getTableId',
        'getStore',
        'getLocalCart',
        'getServerCart',
        'isDineIn',
        'isDineInTableSet',
        'menuAvailableTime',
        'assignedMenuIsAllowed',
        'fetchAssignedMenus',
        'getCheckoutInfo'
      ])
    },

    methods: {
      getDayByOffset(offset) {
        if (offset === 0) {
          return this.$vuetify.t('$vuetify.common.today') || 'Today';
        }
        
        const today = new Date().getDay();
        const targetDayIndex = (today + offset) % 7;
        const dayNames = ['SUNDAY', 'MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY'];
        return this.formatDay(dayNames[targetDayIndex]);
      },
      formatDay(day) {
        const lang = this.$vuetify.lang.current || 'en';
        const dayMaps = {
          en: {
            MONDAY: 'Mon',
            TUESDAY: 'Tues',
            WEDNESDAY: 'Wed',
            THURSDAY: 'Thurs',
            FRIDAY: 'Fri',
            SATURDAY: 'Sat',
            SUNDAY: 'Sun'
          },
          fr: {
            MONDAY: 'Lundi',
            TUESDAY: 'Mardi',
            WEDNESDAY: 'Mercredi',
            THURSDAY: 'Jeudi',
            FRIDAY: 'Vendredi',
            SATURDAY: 'Samedi',
            SUNDAY: 'Dimanche'
          },
          es: {
            MONDAY: 'Lunes',
            TUESDAY: 'Martes',
            WEDNESDAY: 'Miércoles',
            THURSDAY: 'Jueves',
            FRIDAY: 'Viernes',
            SATURDAY: 'Sábado',
            SUNDAY: 'Domingo'
          },
          ko: {
            MONDAY: '월요일',
            TUESDAY: '화요일',
            WEDNESDAY: '수요일',
            THURSDAY: '목요일',
            FRIDAY: '금요일',
            SATURDAY: '토요일',
            SUNDAY: '일요일'
          },
          zh: {
            MONDAY: '星期一',
            TUESDAY: '星期二',
            WEDNESDAY: '星期三',
            THURSDAY: '星期四',
            FRIDAY: '星期五',
            SATURDAY: '星期六',
            SUNDAY: '星期日'
          },
          'zh-TW': {
            MONDAY: '星期一',
            TUESDAY: '星期二',
            WEDNESDAY: '星期三',
            THURSDAY: '星期四',
            FRIDAY: '星期五',
            SATURDAY: '星期六',
            SUNDAY: '星期日'
          }
        };
        const map = dayMaps[lang] || dayMaps['en'];
        return map[day] || day;
      },  
      formatTime(time) {
        const hours = Math.floor(time);
        const minutes = Math.round((time - hours) * 60);
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
        const formattedMinutes = minutes.toString().padStart(2, '0');
        return `${formattedHours}:${formattedMinutes} ${period}`;
      },
      closeModal() {
        this.showConfirmationDialog = false
        this.pendingNavigation = null
      },
      onError() {
        this.imageError = true
      },
      confirmNavigation() {
        this.showConfirmationDialog = false; 
        if (this.pendingNavigation) {
          this.$router.push(this.pendingNavigation).catch(error => {
            console.error(error);
          });
          this.pendingNavigation = null; 
        }
      },
      onMenuClicked() {
        const { scheduledDay, scheduledTime } = this.getCheckoutInfo;
        if ((!scheduledDay || !scheduledTime) && (this.menu && this.menu.schedule)) {
          this.showConfirmationDialog = true;
          this.menuSchedule = this.menu.schedule.items;
          this.pendingNavigation = {
            name: 'store',
            params: {
              gid: this.getStore.groupId,
              sid: this.getStore.storeId,
              mid: this.menu.code,
              restaurantSlug: this.getStore.slug
            },
            query: {
              ...this.$route.query,
              dineInOnly: this.$route.query.dineInOnly,
              tid: this.$route.query.tid,
              vc: this.$route.query.vc
            }
          };
          return;
        }
        this.navigateToMenu();
      },
      navigateToMenu() {
        const tid = this.$route.query.tid;
        const vc = this.$route.query.vc;
        this.$router.push({
          name: 'store',
          params: {
            gid: this.getStore.groupId,
            sid: this.getStore.storeId,
            mid: this.menu.code,
            restaurantSlug: this.getStore.slug,
            tid
          },
          query: {
            dineInOnly: this.$route.query.dineInOnly,
            tid: tid,
            vc: vc
          }
        }).catch(error => {
          console.error(error);
        });
      },
      buildTime(time) {
        return formatTime(revertTimeFraction(time))
      }
    }
  }
</script>

<style scoped>
  .sched-container {
    display: flex;
    flex-direction: column;
  }
  .close-btn {
    position: absolute !important;
    right: 8px !important;
    top: 8px !important;
    margin: 0 !important;
    z-index: 10 !important;
  }
  .card-title {
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .rounded :deep(.v-dialog) {
    border-radius: 16px !important;
    overflow: hidden !important;
  }
  .rounded :deep(.v-card) {
    border-radius: 16px !important;
    overflow: hidden !important;
  }
  .rounded-card {
    border-radius: 16px !important;
    overflow: hidden !important;
    padding: 20px !important;
  }
  .hover-animation-container, .v-card {
    height: 100%;
  }
  .title-text {
    font-size: 1.45em !important;
    margin: 0;
    font-weight: 900;
    width: 100%;
    text-align: center;
  }
  .v-card {
    overflow: hidden;
  }
  .rounded-btn {
    height: 50px;
    font-size: 14px;
    background-color: var(--v-primary-base)!important;
    color: white !important;
    font-weight: bold;
    width: 48.5%;
    margin-top: 1rem;
    border-radius: 25px;
  }
  .disabled .v-card {
    background-color: rgba(240, 240, 240, 0.65) !important;
    color: #3a3939;
  }

  #hoverOverlay {
    position: absolute;
    top: 100%;

    background-color: rgba(255, 255, 255, 0.92);

    text-align: left;

    width: 100%;
    height: 100%;

    padding: 40px;

    transition: all 0.3s ease-in-out;
    -webkit-transition: all 0.3s ease-in-out;
    -moz-transition: all 0.3s ease-in-out;
    -ms-transition: all 0.3s ease-in-out;
    -o-transition: all 0.3s ease-in-out;
  }
  .hover-animation-container:hover #hoverOverlay {
    top: 0;
  }

  .block-with-text {
    overflow: hidden;
    text-overflow: ellipsis;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical !important;
  }

  .menuTitle {
    font-size: var(--text-size-2);
    font-weight: 600;;

    margin: 5px;
  }
  .menuTitle:not(.block-with-text) {
    padding: 35px 0px;
  }
  .menuDescription {
    font-size: var(--text-size-1);
    text-align: left;

    margin: 5px;
  }
</style>
<style>
  .mobileDetails {
    background-color: rgba(250, 250, 250, 0.95);
    border-color: silver;
    border-width: 0px 0.5px 0.5px 0px;
    border-style: solid;

    z-index: 0;
    padding: 5px 15px 5px 5px;

    font-size: 18px;
    font-weight: 700;
    text-align: left;
  }
  .fixed-details {
    position: absolute;
    top: 0px;
    left: 0px;
  }
  .fixed-details>div {
    font-size: 16px;
    font-weight: 500;
  }
</style>
